import React from 'react'
import cn from 'utils/tailwind/cn'

// ICONS REPO: https://heroicons.com/

function AddUserIcon() {
  return (
    <svg
      className="fill-current w-full"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="heroicon-ui"
        d="M19 10h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2h-2a1 1 0 0 1 0-2h2V8a1 1 0 0 1 2 0v2zM9 12A5 5 0 1 1 9 2a5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm8 11a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h5a5 5 0 0 1 5 5v2z"
      />
    </svg>
  )
}

export function Close({
  color = '#6b7280',
  circle = true,
  className = '',
  ...props
}) {
  return (
    <svg
      className={cn('float-right h-8 w-8', className)}
      height="512"
      stroke={color}
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {circle && (
        <path
          d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
          fill="none"
          stroke="inherit"
          strokeMiterlimit="10"
          strokeWidth="32"
        />
      )}
      <path
        d="M320 320L192 192"
        fill="none"
        stroke="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
      />
      <path
        d="M192 320L320 192"
        fill="none"
        stroke="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
      />
    </svg>
  )
}

function Search({ size = 6, color, className }) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={color || 'text-txt'}
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Link({ size = 5, color, className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function Download({ size = 5, color, className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function DocumentDownload({ size = 5, color, className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function ExternalLink({ size = 6, color = 'text-txt', className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ExternalLinkDense({ size = 5, color, className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
      <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
    </svg>
  )
}

function Clipboard({ size = 5, color, className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Cog({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function Copy({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function CheckCircle({ size = 5, color, className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function Gesture({ size = 5, color, className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M3.72 6.04c.47.46 1.21.48 1.71.06.37-.32.69-.51.87-.43.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1h1.21c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25h-1.22c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3c-1.09 0-2.04.63-2.7 1.22-.53.48-.53 1.32-.02 1.82zm10.16 12.51c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function Keyboard({ size = 5, color, className }) {
  return (
    <svg
      className={cn(color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={color || 'text-txt'}
        d="M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm8 7H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm1-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
      />
    </svg>
  )
}

function Trash({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function CheckBadge({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function Check({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 13l4 4L19 7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Pencil({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Mail({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
    </svg>
  )
}

function MailOutline({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ChevronDown({
  size = 5,
  color = undefined,
  inheritColor,
  className = undefined,
}) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 9l-7 7-7-7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ChevronUp({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 15l7-7 7 7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ArrowDownSmall({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 13l-5 5m0 0l-5-5m5 5V6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ArrowUpSmall({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 11l5-5m0 0l5 5m-5-5v12"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ArrowLeftSmall({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 17l-5-5m0 0l5-5m-5 5h12"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ArrowRightSmall({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7l5 5m0 0l-5 5m5-5H6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ChevronLeft({
  size = 5,
  color = '',
  inheritColor = true,
  className = '',
  ...props
}) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function DeviceTablet({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Form({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Packet({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function X({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 18L18 6M6 6l12 12"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ArrowsExpand({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ArrowPath({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function LockClosed({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ShieldExclamation({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ClipboardList({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ClipboardCheck({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function CloseCircle({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function CloseCircleFilled({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function Plus({ size = 5, color = '', inheritColor = '', className = '' }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4v16m8-8H4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function PlusCircle({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function DotsVerticalDense({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
    </svg>
  )
}

function FaceSad({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function CubeEmpty({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ChevronDoubleRight({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 5l7 7-7 7M5 5l7 7-7 7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ChevronRight({
  size = 5,
  color = '',
  inheritColor = true,
  className = '',
  ...props
}) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function ChevronRightSmall({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function Refresh({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Eye({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
    >
      <path
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function EyeOff({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function StatusOffline({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

function CheckCircleOutline({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

function UserCircle({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function UserAdd({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Phone({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
    </svg>
  )
}

function PhoneOutline({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function ChatOutline({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

function Chat({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function Merge({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17,20.41L18.41,19L15,15.59L13.59,17M7.5,8H11V13.59L5.59,19L7,20.41L13,14.41V8H16.5L12,3.5"
        fill="currentColor"
      />
    </svg>
  )
}

function Support({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Action / help outline">
        <mask
          height="20"
          id="mask0_1_5"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="20"
          x="2"
          y="2"
        >
          <g id="Icon Mask">
            <path
              clipRule="evenodd"
              d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12ZM11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17ZM8.18 8.83C8.73 7.01 10.55 5.74 12.61 6.04C14.35 6.3 15.72 7.77 15.96 9.51C16.1881 11.1235 15.2957 11.9021 14.4344 12.6535C14.2762 12.7916 14.119 12.9288 13.97 13.07C13.85 13.18 13.74 13.29 13.64 13.41C13.635 13.415 13.63 13.4225 13.625 13.43C13.62 13.4375 13.615 13.445 13.61 13.45C13.51 13.57 13.41 13.7 13.33 13.84C13.32 13.855 13.3125 13.87 13.305 13.885C13.2975 13.9 13.29 13.915 13.28 13.93C13.11 14.23 13 14.58 13 15H11C11 14.5 11.08 14.09 11.2 13.75C11.2044 13.7368 11.2068 13.7256 11.2091 13.7155C11.2119 13.7025 11.2144 13.6912 11.22 13.68C11.225 13.665 11.2325 13.6525 11.24 13.64C11.2475 13.6275 11.255 13.615 11.26 13.6C11.33 13.42 11.42 13.25 11.51 13.1C11.515 13.09 11.52 13.0825 11.525 13.075C11.53 13.0675 11.535 13.06 11.54 13.05C11.54 13.045 11.5425 13.0425 11.545 13.04C11.5475 13.0375 11.55 13.035 11.55 13.03C11.8906 12.5171 12.3473 12.1658 12.7745 11.8373C13.3883 11.3652 13.941 10.9401 14 10.15C14.08 9.18 13.38 8.25 12.43 8.05C11.4 7.83 10.45 8.44 10.13 9.33C9.99 9.71 9.66 10 9.25 10H9.05C8.44 10 8 9.41 8.18 8.83Z"
              fill="black"
              fillRule="evenodd"
              id="Round"
            />
          </g>
        </mask>
        <g mask="url(#mask0_1_5)">
          <rect fill="#393939" height="24" id="Color Fill" width="24" />
        </g>
      </g>
    </svg>
  )
}

function Duplicate({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function ChevronUpDown({ size = 5, color, inheritColor, className }) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="currentColor"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
        fillRule="evenodd"
      />
    </svg>
  )
}

function AzureAD({ size = 30, color, inheritColor, className }) {
  return (
    <svg
      className={cn(color, className)}
      color={inheritColor ? 'inherit' : ''}
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 954.1 158.2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="title4">active-directory</title>
      <g id="Layer_2_1_" transform="translate(0 -33.561)">
        <g id="Layer_1-2">
          <path
            className="st0"
            d="M158.6 154.2v33.3c0 3.9-1.2 4.7-4.9 4.1-24.8-3.7-49.9-7.1-74.9-10.6-4.5-.6-6.1-2.2-6.1-7.1.4-17.7.2-35.5 0-53.4 0-3.9 1.2-5.1 5.1-5.1 25.6.2 50.8.2 75.9.2 4.1 0 5.1 1.6 5.1 5.3-.4 11.2-.2 22.2-.2 33.3z"
            fill="#0072c6"
            id="path6"
          />
          <path
            className="st0"
            d="M116.1 109.2c-12.6 0-25.2-.2-37.8 0-3.9 0-5.5-.8-5.5-5.3.2-18.1.2-35.9 0-53.8 0-3.5 1.2-4.7 4.5-5.3 25.8-3.7 51.6-7.3 77.4-11.2 4.5-.6 3.7 2.4 3.7 4.9 0 16 .2 32.3 0 48.3 0 5.9-.2 11.8 0 17.7.2 3.7-1.2 4.7-4.7 4.7-12.4-.2-25 0-37.6 0z"
            fill="#0072c6"
            id="path8"
          />
          <path
            className="st0"
            d="M32.7 115.9h28.2c3 0 4.3 1 4.3 4.1v55.6c0 3.2-1.4 3.5-4.3 3.2-18.7-2.8-37.4-5.5-56-8.1-3.7-.6-4.9-1.8-4.9-5.7.2-14.8.2-29.6 0-44.7 0-3.7 1-4.7 4.7-4.7 9.5.3 18.6.3 28 .3z"
            fill="#0072c6"
            id="path10"
          />
          <path
            className="st0"
            d="M32.7 109.2H4.9c-3.5 0-4.7-1.2-4.7-4.9.2-14.6.2-29.2 0-43.9 0-3.5 1-4.7 4.7-5.3 18.7-2.4 37.4-5.1 56-8.1 4.3-.6 4.7.8 4.7 4.3v53.2c0 3.9-1.6 4.5-5.1 4.5-9.3 0-18.7.2-27.8.2z"
            fill="#0072c6"
            id="path12"
          />
          <path
            className="st0"
            d="M228.8 64.7c-.2-3-.4-6.9-.4-9.7h-.2c-.6 2.6-1.8 5.7-2.8 8.7l-3.9 10.8h-2.2l-3.5-10.6c-1-2.8-1.8-5.9-2.6-8.7-.2 2.6-.2 6.5-.4 9.9l-.6 9.5h-2.6l1.6-22.5h3.7l3.9 11c1 2.6 1.6 5.3 2.2 7.7h.2c.6-2.2 1.4-4.9 2.4-7.7l4.1-11h3.7l1.4 22.5h-3.2l-.8-9.9z"
            fill="#0072c6"
            id="path14"
          />
          <path
            className="st0"
            d="M240.4 53.9c0 1-.8 1.8-1.8 1.8h-.2c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8c1.2 0 2 .8 2 1.8zm-3.2 20.8v-16h3v16h-3z"
            fill="#0072c6"
            id="path16"
          />
          <path
            className="st0"
            d="M256.4 74c-1.4.6-3 1-4.7 1-4.9 0-8.1-3.2-8.1-8.3-.2-4.7 3.2-8.5 7.9-8.7h.8c1.4 0 2.8.2 4.1.8l-.6 2.2c-1-.4-2.2-.8-3.5-.6-3.7 0-5.7 2.6-5.7 6.1 0 3.9 2.4 6.1 5.7 6.1 1.2 0 2.4-.2 3.5-.8l.6 2.2z"
            fill="#0072c6"
            id="path18"
          />
          <path
            className="st0"
            d="M259.7 63.5c0-1.8-.2-3.5-.2-4.9h2.6l.2 3.2h.2c.6-2 2.4-3.5 4.5-3.5.2 0 .6 0 .8.2v2.6c-.2-.2-.6-.2-1-.2-2 0-3.5 1.6-3.9 3.9 0 .4-.2.8-.2 1.2v8.7h-2.8l-.2-11.2z"
            fill="#0072c6"
            id="path20"
          />
          <path
            className="st0"
            d="M285.1 66.5c.2 4.3-3 8.1-7.3 8.3h-.6c-4.3 0-7.7-3.2-7.7-8.3 0-5.5 3.7-8.5 8.1-8.5 4 0 7.5 3.5 7.5 8.5zm-12.8 0c0 3.2 1.6 6.1 4.9 6.1 3.2 0 4.9-3 4.9-6.1 0-2.8-1.2-6.3-4.9-6.3-3.9.2-4.9 3.5-4.9 6.3z"
            fill="#0072c6"
            id="path22"
          />
          <path
            className="st0"
            d="M288.3 71.6c1.2.8 2.4 1.2 3.9 1.2 2 0 3-1 3-2.4 0-1.2-.8-2-3-3-2.8-1-4.3-2.6-4.3-4.7 0-2.6 2-4.7 5.5-4.7 1.4 0 2.8.4 4.1 1l-.6 2c-1-.6-2.2-1-3.2-1-1.4-.2-2.6.8-2.6 2.2 0 1.2 1 1.8 3 2.6 2.6 1 4.3 2.4 4.3 4.9 0 2.8-2.2 4.9-6.1 4.9-1.6 0-3-.4-4.5-1.2l.5-1.8z"
            fill="#0072c6"
            id="path24"
          />
          <path
            className="st0"
            d="M316.5 66.5c.2 4.3-3 8.1-7.3 8.3h-.6c-4.3 0-7.7-3.2-7.7-8.3 0-5.5 3.7-8.5 8.1-8.5 4.1 0 7.5 3.5 7.5 8.5zm-12.7 0c0 3.2 1.6 6.1 4.9 6.1s4.9-3 4.9-6.1c0-2.8-1.2-6.3-4.9-6.3s-4.9 3.5-4.9 6.3z"
            fill="#0072c6"
            id="path26"
          />
          <path
            className="st0"
            d="M320.4 74.7v-14h-2.2v-2.2h2.2v-.8c-.2-2 .4-4.1 1.8-5.7 1-1 2.4-1.6 3.9-1.6.8 0 1.6.2 2.4.4l-.4 2.2c-.6-.2-1.2-.4-1.8-.4-2.4 0-3 2.2-3 4.7v1h3.9v2.2h-3.9v13.8l-2.9.4z"
            fill="#0072c6"
            id="path28"
          />
          <path
            className="st0"
            d="M333.8 53.7v4.7h4.3v2.2h-4.3v8.7c0 2 .6 3 2.2 3 .6 0 1.2 0 1.6-.2l.2 2.2c-.8.4-1.6.4-2.6.4-1.2 0-2.2-.4-3.2-1.2-.8-1.2-1.2-2.8-1-4.3v-8.9h-2.4v-2.2h2.4v-3.9l2.8-.5z"
            fill="#0072c6"
            id="path30"
          />
          <path
            className="st0"
            d="M227 135.8l-7.7 23.8h-10.2L234.9 84h11.6l25.8 75.5h-10.4l-8.1-23.8H227zm24.8-7.5l-7.3-21.7c-1.6-4.9-2.8-9.5-3.9-13.8h-.4c-1 4.5-2.2 9.1-3.7 13.6l-7.3 21.9h22.6z"
            fill="#0072c6"
            id="path32"
          />
          <path
            className="st0"
            d="M320.2 157.7c-4.9 2.2-10.2 3.2-15.6 3.2-16.2 0-27-11.2-27-27.6s11.6-28.8 29-28.8c4.7 0 9.3.8 13.6 2.8l-2.2 7.5c-3.5-1.8-7.5-2.6-11.6-2.6-12.4 0-19.1 9.3-19.1 20.5 0 12.6 8.1 20.3 18.9 20.3 4.1 0 8.3-.8 12-2.6l2 7.3z"
            fill="#0072c6"
            id="path34"
          />
          <path
            className="st0"
            d="M345.2 89.9v15.6h14v7.3h-14V142c0 6.7 1.8 10.6 7.3 10.6 1.8 0 3.9-.2 5.7-.6l.4 7.3c-1.8 1-4.9 1.4-8.9 1.4-4.1.2-7.9-1.4-10.6-4.1-2.6-3.2-3.7-7.7-3.7-14.2v-29.6h-8.5v-7.3h8.3V92.3l10-2.4z"
            fill="#0072c6"
            id="path36"
          />
          <path
            className="st0"
            d="M381.3 90.3c0 3.2-2.4 5.9-5.7 6.1h-.4c-3.2 0-5.9-2.4-5.9-5.5v-.4c-.2-3.2 2.4-6.1 5.7-6.1h.4c3.3-.4 5.9 2.4 5.9 5.9 0-.2 0-.2 0 0zm-10.9 69.4v-54.2h9.7v54h-9.7v.2z"
            fill="#0072c6"
            id="path38"
          />
          <path
            className="st0"
            d="M400.4 105.5L411 136c1.8 4.9 3.2 9.5 4.5 14h.4c1.2-4.5 2.8-9.1 4.5-14l10.6-30.5h10.4l-21.3 54h-9.5l-20.5-54h10.3z"
            fill="#0072c6"
            id="path40"
          />
          <path
            className="st0"
            d="M454.8 134.3c.2 13.4 8.7 18.9 18.5 18.9 7.1 0 11.6-1.2 15-2.8l1.6 7.1c-5.7 2.4-11.8 3.7-18.1 3.5-16.6 0-26.6-11.2-26.6-27.4 0-16.4 9.5-29.2 25.6-29.2 17.7 0 22.3 15.4 22.3 25.4 0 1.6-.2 3-.4 4.7h-37.9v-.2zm28.8-7.1c.2-6.1-2.6-15.8-13.6-15.8-9.9 0-14.4 9.1-15.2 15.8h28.8z"
            fill="#0072c6"
            id="path42"
          />
          <path
            className="st0"
            d="M529.3 85.2c6.9-1 13.8-1.6 20.9-1.6 14 0 24 3.2 30.5 9.5 6.7 6.1 10.6 15 10.6 27 0 12.4-3.9 22.3-11 29.4-7.1 7.1-18.7 11-33.3 11-5.9 0-12-.2-17.9-1l.2-74.3zm10 66.8c3.2.4 6.5.6 9.7.6 20.9 0 32.3-11.6 32.3-32.1.2-17.9-9.9-29-30.5-29-3.9 0-7.7.4-11.6 1l.1 59.5z"
            fill="#0072c6"
            id="path44"
          />
          <path
            className="st0"
            d="M615 90.3c0 3.2-2.4 5.9-5.7 6.1h-.4c-3.2 0-5.9-2.4-5.9-5.5v-.4c-.2-3.2 2.4-6.1 5.7-6.1h.4c3.1-.4 5.9 2.4 5.9 5.9 0-.2 0-.2 0 0zm-11.1 69.4v-54.2h9.7v54h-9.7v.2z"
            fill="#0072c6"
            id="path46"
          />
          <path
            className="st0"
            d="M630 122.4c0-6.3-.2-11.8-.4-16.9h8.7l.4 10.6h.4c2.6-7.3 8.7-11.8 15.2-11.8 1 0 1.8 0 2.6.2v9.3c-1-.2-2-.4-3.2-.4-7.1 0-11.8 5.3-13.2 12.6-.4 1.4-.4 3-.4 4.5v29h-9.7l-.4-37.1z"
            fill="#0072c6"
            id="path48"
          />
          <path
            className="st0"
            d="M671.1 134.3c.2 13.4 8.7 18.9 18.5 18.9 7.1 0 11.6-1.2 15-2.8l1.6 7.1c-5.7 2.4-11.8 3.7-18.1 3.5-16.6 0-26.6-11.2-26.6-27.4 0-16.4 9.5-29.2 25.6-29.2 17.7 0 22.3 15.4 22.3 25.4 0 1.6-.2 3-.4 4.7h-37.9v-.2zm28.8-7.1c.2-6.1-2.6-15.8-13.6-15.8-9.9 0-14.4 9.1-15.2 15.8h28.8z"
            fill="#0072c6"
            id="path50"
          />
          <path
            className="st0"
            d="M760.2 157.7c-4.9 2.2-10.2 3.2-15.6 3.2-16.2 0-27-11.2-27-27.6s11.6-28.8 29-28.8c4.7 0 9.3.8 13.6 2.8l-2.2 7.5c-3.5-1.8-7.5-2.6-11.6-2.6-12.4 0-19.1 9.3-19.1 20.5 0 12.6 8.1 20.3 18.9 20.3 4.1 0 8.3-.8 12-2.6l2 7.3z"
            fill="#0072c6"
            id="path52"
          />
          <path
            className="st0"
            d="M785.2 89.9v15.6h14v7.3h-14V142c0 6.7 1.8 10.6 7.3 10.6 1.8 0 3.9-.2 5.7-.6l.4 7.3c-1.8 1-4.9 1.4-8.9 1.4-4.1.2-7.9-1.4-10.6-4.1-2.6-3.2-3.7-7.7-3.7-14.2v-29.6h-8.3v-7.3h8.3V92.3l9.8-2.4z"
            fill="#0072c6"
            id="path54"
          />
          <path
            className="st0"
            d="M858.7 132.5c0 19.9-14.6 28.4-27.2 28.4-14.2 0-25.8-10.6-25.8-28.2 0-18.1 12.4-28.4 27-28.4 15.2 0 26 10.8 26 28.2zm-42.9.2c0 11 5.5 20.7 16.4 20.7 10.8 0 16.6-9.7 16.6-20.9 0-9.5-4.5-21.1-16.6-21.1-12.1 0-16.4 11.6-16.4 21.3z"
            fill="#0072c6"
            id="path56"
          />
          <path
            className="st0"
            d="M871.1 122.4c0-6.3-.2-11.8-.4-16.9h8.7l.4 10.6h.4c2.6-7.3 8.7-11.8 15.2-11.8 1 0 1.8 0 2.6.2v9.3c-1-.2-2-.4-3.2-.4-7.1 0-11.8 5.3-13.2 12.6-.4 1.4-.4 3-.4 4.5v29h-9.7l-.4-37.1z"
            fill="#0072c6"
            id="path58"
          />
          <path
            className="st0"
            d="M914.1 105.5l11.8 31.9c1.2 3.5 2.6 7.7 3.5 11.2h.2c1-3.2 2-7.3 3.5-11.2l10.8-31.9h10.4l-14.8 38.6c-7.1 18.5-11.8 28.2-18.5 34.1-3.5 3-7.5 5.1-12 6.3l-2.4-8.3c3.2-1 6.1-2.6 8.7-4.9 3.5-3 6.3-6.7 8.1-11 .4-.8.8-1.6.8-2.4 0-1-.4-1.8-.8-2.6l-19.9-49.7h10.6z"
            fill="#0072c6"
            id="path60"
          />
        </g>
      </g>
    </svg>
  )
}

function BuildingOffice({
  size = 5,
  color = '',
  inheritColor = '',
  className = '',
  stroke = 'currentColor',
}) {
  return (
    <svg
      className={cn(!inheritColor && 'text-txt', color, className)}
      fill="none"
      stroke={stroke}
      strokeWidth="1.5"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SignatureIcon({ width = 20, height = 20 }) {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Content / gesture">
        <mask
          height="16"
          id="mask0_502_242"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="16"
          x="2"
          y="2"
        >
          <g id="Icon Mask">
            <path
              clipRule="evenodd"
              d="M4.46644 5.09168C4.04977 5.44168 3.43311 5.42501 3.04144 5.04168C2.61644 4.62501 2.61644 3.92501 3.05811 3.52501C3.60811 3.03335 4.39977 2.50835 5.30811 2.50835C6.03311 2.50835 7.39977 3.08335 7.39977 4.89168C7.39977 6.02501 6.96644 6.67501 6.31644 7.62501C5.94144 8.17501 5.06644 9.65001 4.77477 10.5583C4.47477 11.4667 4.69977 12.1583 5.07477 12.1583C5.41828 12.1583 5.76179 11.7448 5.97315 11.4904C5.98228 11.4794 5.99115 11.4687 5.99977 11.4583C6.19144 11.2583 7.42477 9.80001 7.90811 9.19168C8.54144 8.41668 10.1498 6.82501 12.0248 6.82501C14.4748 6.82501 15.2581 8.95001 15.3831 10.325H16.3998C16.9748 10.325 17.4414 10.7917 17.4414 11.3667C17.4414 11.9417 16.9748 12.4083 16.3998 12.4083H15.3914C15.0581 16.3833 12.8414 17.4917 11.4831 17.4917C10.0081 17.4917 8.80811 16.3333 8.80811 14.9167C8.80811 13.5 10.1414 10.975 13.2914 10.4417C13.2855 10.3998 13.2799 10.357 13.2743 10.3138C13.192 9.68659 13.0955 8.95001 11.8248 8.95001C10.7831 8.95001 9.43311 10.575 8.42477 11.8167L8.41422 11.8297C7.49419 12.9653 6.76305 13.8677 5.87477 14.125C5.12477 14.35 4.29977 14.2083 3.67477 13.7417C2.95811 13.2083 2.55811 12.325 2.55811 11.2583C2.55811 9.50217 4.20751 7.08244 4.7712 6.25549C4.85481 6.13284 4.91453 6.04522 4.94144 6.00001C5.19144 5.59168 5.60811 4.90001 5.19144 4.73335C5.04144 4.66668 4.77477 4.82501 4.46644 5.09168ZM10.8914 14.8667C10.8914 15.25 11.2498 15.4667 11.5081 15.4667C12.0914 15.4667 13.0331 14.8083 13.2831 12.5667C11.4998 13.0333 10.8914 14.3667 10.8914 14.8667Z"
              fill="black"
              fillRule="evenodd"
              id="Round"
            />
          </g>
        </mask>
        <g mask="url(#mask0_502_242)">
          <rect fill="black" height="20" id="Color Fill" width="20" />
        </g>
      </g>
    </svg>
  )
}

export function MagnifyingGlassPlus({
  size = 6,
  color,
  inheritColor,
  className,
}) {
  return (
    <svg
      className={cn(color, className)}
      color={inheritColor ? 'inherit' : ''}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MagnifyingGlassMinus({
  size = 6,
  color,
  inheritColor,
  className,
}) {
  return (
    <svg
      className={cn(color, className)}
      color={inheritColor ? 'inherit' : ''}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM13.5 10.5h-6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Alert({ fill, size }) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="20"
        id="mask0_2_62"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="20"
        x="2"
        y="2"
      >
        <path
          clipRule="evenodd"
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 13C11.45 13 11 12.55 11 12V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V12C13 12.55 12.55 13 12 13ZM11 15V17H13V15H11Z"
          fill="black"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_2_62)">
        <rect fill={fill || '#2E5AAC'} height="24" width="24" />
      </g>
    </svg>
  )
}

export function Details(props) {
  return (
    <svg
      fill="#858C94"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        height="10"
        id="mask0_3_3123"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="18"
        x="3"
        y="7"
      >
        <path
          clipRule="evenodd"
          d="M8 15L18 15C18.5 15 19 15.45 19 16C19 16.55 18.5 17 18 17H8C7.5 17 7 16.55 7 16C7 15.45 7.5 15 8 15ZM8.00007 11H16.0001C16.5001 11 17.0001 11.45 17.0001 12C17.0001 12.55 16.5001 13 16.0001 13H8.00007C7.50007 13 7.00007 12.55 7.00007 12C7.00007 11.45 7.50007 11 8.00007 11ZM20 7H8C7.45 7 7 7.45 7 8C7 8.55 7.45 9 8 9H20C20.55 9 21 8.55 21 8C21 7.45 20.55 7 20 7ZM3 7H5V9H3V7ZM5 17V15H3V17H5ZM3 11H5V13H3V11Z"
          fill="black"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_3_3123)">
        <path d="M24 24H1.43051e-06V1.43051e-06H24V24Z" fill="inherit" />
      </g>
    </svg>
  )
}

export function DetailsActive() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill="#C2FF93"
        height="24"
        rx="3"
        transform="rotate(180 24 24)"
        width="24"
        x="24"
        y="24"
      />
      <mask
        height="10"
        id="mask0_3_3124"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="18"
        x="3"
        y="7"
      >
        <path
          clipRule="evenodd"
          d="M8 15L18 15C18.5 15 19 15.45 19 16C19 16.55 18.5 17 18 17H8C7.5 17 7 16.55 7 16C7 15.45 7.5 15 8 15ZM8.00007 11H16.0001C16.5001 11 17.0001 11.45 17.0001 12C17.0001 12.55 16.5001 13 16.0001 13H8.00007C7.50007 13 7.00007 12.55 7.00007 12C7.00007 11.45 7.50007 11 8.00007 11ZM20 7H8C7.45 7 7 7.45 7 8C7 8.55 7.45 9 8 9H20C20.55 9 21 8.55 21 8C21 7.45 20.55 7 20 7ZM3 7H5V9H3V7ZM5 17V15H3V17H5ZM3 11H5V13H3V11Z"
          fill="black"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_3_3124)">
        <path d="M24 24H1.43051e-06V1.43051e-06H24V24Z" fill="#278D3E" />
      </g>
    </svg>
  )
}

function ChevronPipeRight({ width = '30', height = '30' }) {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 30 30"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Navigation / first page">
        <mask
          height="16"
          id="mask0_3_3180"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="16"
          x="7"
          y="7"
        >
          <g id="Icon Mask">
            <path
              clipRule="evenodd"
              d="M20.0015 21.25C20.0015 21.9375 20.564 22.5 21.2515 22.5C21.939 22.5 22.5015 21.9375 22.5015 21.25V8.75C22.5015 8.0625 21.939 7.5 21.2515 7.5C20.564 7.5 20.0015 8.0625 20.0015 8.75V21.25ZM12.7265 15L7.87646 10.1375C7.38896 9.6625 7.38896 8.8625 7.86396 8.3875C8.35146 7.9 9.13896 7.9 9.62646 8.3875L15.364 14.125C15.8515 14.6125 15.8515 15.4 15.364 15.8875L9.62646 21.625C9.39292 21.8591 9.07586 21.9906 8.74521 21.9906C8.41457 21.9906 8.0975 21.8591 7.86396 21.625C7.37646 21.1375 7.37646 20.35 7.86396 19.8625L12.7265 15Z"
              fill="black"
              fillRule="evenodd"
              id="Round"
            />
          </g>
        </mask>
        <g mask="url(#mask0_3_3180)">
          <rect
            fill="#858C94"
            height="30"
            id="Color Fill"
            transform="rotate(-180 30 30)"
            width="30"
            x="30"
            y="30"
          />
        </g>
      </g>
    </svg>
  )
}

function KebabMenu() {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Navigation / more vert">
        <mask
          height="14"
          id="mask0_2_2138"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="4"
          x="8"
          y="3"
        >
          <g id="Icon Mask">
            <path
              clipRule="evenodd"
              d="M10 6.66665C10.9167 6.66665 11.6667 5.91665 11.6667 4.99998C11.6667 4.08331 10.9167 3.33331 10 3.33331C9.08337 3.33331 8.33337 4.08331 8.33337 4.99998C8.33337 5.91665 9.08337 6.66665 10 6.66665ZM10 8.33331C9.08337 8.33331 8.33337 9.08331 8.33337 9.99998C8.33337 10.9166 9.08337 11.6666 10 11.6666C10.9167 11.6666 11.6667 10.9166 11.6667 9.99998C11.6667 9.08331 10.9167 8.33331 10 8.33331ZM8.33337 15C8.33337 14.0833 9.08337 13.3333 10 13.3333C10.9167 13.3333 11.6667 14.0833 11.6667 15C11.6667 15.9166 10.9167 16.6666 10 16.6666C9.08337 16.6666 8.33337 15.9166 8.33337 15Z"
              fill="black"
              fillRule="evenodd"
              id="Round"
            />
          </g>
        </mask>
        <g mask="url(#mask0_2_2138)">
          <rect fill="#858C94" height="20" id="Color Fill" width="20" />
        </g>
      </g>
    </svg>
  )
}

function Spinner({ size = 24 }) {
  const colorToUse = 'currentColor'

  return (
    <svg
      height={`${size}px`}
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 100 100"
      width={`${size}px`}
    >
      <g transform="rotate(0 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.875s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(45 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.75s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(90 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.625s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(135 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.5s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(180 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.375s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(225 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.25s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(270 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="-0.125s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
      <g transform="rotate(315 50 50)">
        <rect
          fill={colorToUse}
          height="12"
          rx="6"
          ry="6"
          width="12"
          x="44"
          y="20"
        >
          <animate
            attributeName="opacity"
            begin="0s"
            dur="1s"
            keyTimes="0;1"
            repeatCount="indefinite"
            values="1;0"
          />
        </rect>
      </g>
    </svg>
  )
}

function FilterAlt({ size = 24 }) {
  return (
    <svg
      fill="none"
      height={`${size}px`}
      viewBox={`0 0 24 24`}
      width={`${size}px`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="16"
        id="mask0_507_2123"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="16"
        x="4"
        y="4"
      >
        <path
          d="M4.24993 5.61C6.26993 8.2 9.99993 13 9.99993 13V19C9.99993 19.55 10.4499 20 10.9999 20H12.9999C13.5499 20 13.9999 19.55 13.9999 19V13C13.9999 13 17.7199 8.2 19.7399 5.61C20.2499 4.95 19.7799 4 18.9499 4H5.03993C4.20993 4 3.73993 4.95 4.24993 5.61Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_507_2123)">
        <rect fill="white" height="24" width="24" />
      </g>
    </svg>
  )
}

function TrashCircleAround({ size = 30 }) {
  return (
    <svg
      fill="none"
      height={`${size}px`}
      viewBox="0 0 30 30"
      width={`${size}px`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 18L13 15" stroke="#33363F" stroke-linecap="round" />
      <path d="M17 18L17 15" stroke="#33363F" stroke-linecap="round" />
      <path
        d="M5.5 10H15H24V10C23.0681 10 22.6022 10 22.2346 10.1522C21.7446 10.3552 21.3552 10.7446 21.1522 11.2346C21 11.6022 21 12.0681 21 13V19C21 20.8856 21 21.8284 20.4142 22.4142C19.8284 23 18.8856 23 17 23H13C11.1144 23 10.1716 23 9.58579 22.4142C9 21.8284 9 20.8856 9 19V13.5C9 12.0955 9 11.3933 8.66294 10.8889C8.51702 10.6705 8.32952 10.483 8.11114 10.3371C7.60669 10 6.90446 10 5.5 10V10Z"
        stroke="#33363F"
        stroke-linecap="round"
      />
      <path
        d="M13.0681 6.37059C13.1821 6.26427 13.4332 6.17033 13.7825 6.10332C14.1318 6.03632 14.5597 6 15 6C15.4403 6 15.8682 6.03632 16.2175 6.10332C16.5668 6.17033 16.8179 6.26427 16.9319 6.37059"
        stroke="#33363F"
        stroke-linecap="round"
      />
      <circle cx="15" cy="15" r="14.5" stroke="#33363F" />
      <circle cx="15" cy="15" r="14.5" stroke="#33363F" />
    </svg>
  )
}

function ArchiveCircleAround({ size = 30 }) {
  return (
    <svg
      fill="none"
      height={`${size}px`}
      viewBox="0 0 30 30"
      width={`${size}px`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="14.5" stroke="#33363F" />
      <path
        d="M7.5 11.5C7.5 9.61438 7.5 8.67157 8.08579 8.08579C8.67157 7.5 9.61438 7.5 11.5 7.5H18.5C20.3856 7.5 21.3284 7.5 21.9142 8.08579C22.5 8.67157 22.5 9.61438 22.5 11.5V18.5C22.5 20.3856 22.5 21.3284 21.9142 21.9142C21.3284 22.5 20.3856 22.5 18.5 22.5H11.5C9.61438 22.5 8.67157 22.5 8.08579 21.9142C7.5 21.3284 7.5 20.3856 7.5 18.5V11.5Z"
        stroke="#33363F"
      />
      <path
        d="M7.5 15V15C7.5 15.4647 7.5 15.697 7.53843 15.8902C7.69624 16.6836 8.31644 17.3038 9.10982 17.4616C9.30302 17.5 9.53535 17.5 10 17.5H10.5629C10.9299 17.5 11.1134 17.5 11.2717 17.5546C11.4575 17.6186 11.6203 17.7359 11.7398 17.8919C11.8416 18.0249 11.8997 18.199 12.0157 18.5472L12.0833 18.75C12.2649 19.2948 12.3557 19.5672 12.5525 19.7439C12.6058 19.7918 12.6641 19.8338 12.7263 19.8692C12.9563 20 13.2434 20 13.8176 20H16.1824C16.7566 20 17.0437 20 17.2737 19.8692C17.3359 19.8338 17.3942 19.7918 17.4475 19.7439C17.6443 19.5672 17.7351 19.2948 17.9167 18.75L17.9843 18.5472C18.1003 18.199 18.1584 18.0249 18.2602 17.8919C18.3797 17.7359 18.5425 17.6186 18.7283 17.5546C18.8866 17.5 19.0701 17.5 19.4371 17.5H20C20.4647 17.5 20.697 17.5 20.8902 17.4616C21.6836 17.3038 22.3038 16.6836 22.4616 15.8902C22.5 15.697 22.5 15.4647 22.5 15V15"
        stroke="#33363F"
      />
      <path
        d="M12.9167 13.75L15.0001 15.8333M15.0001 15.8333L17.0834 13.75M15.0001 15.8333L15.0001 9.99999"
        stroke="#33363F"
      />
    </svg>
  )
}

export function CalendarIcon() {
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 2.66669H3.33333C2.59695 2.66669 2 3.26364 2 4.00002V13.3334C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3334V4.00002C14 3.26364 13.403 2.66669 12.6667 2.66669Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10.6666 1.33331V3.99998"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M5.33337 1.33331V3.99998"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M2 6.66669H14"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export const Clock = (props) => (
  <svg
    height="32"
    viewBox="0 0 256 256"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24m0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88m64-88a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V72a8 8 0 0 1 16 0v48h48a8 8 0 0 1 8 8"></path>
  </svg>
)

export const PaperPlane = (props) => (
  <svg
    height="32"
    viewBox="0 0 256 256"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M227.32 28.68a16 16 0 0 0-15.66-4.08h-.15L19.57 82.84a16 16 0 0 0-2.49 29.8L102 154l41.3 84.87a15.86 15.86 0 0 0 14.44 9.13q.69 0 1.38-.06a15.88 15.88 0 0 0 14-11.51l58.2-191.94v-.15a16 16 0 0 0-4-15.66m-69.49 203.17-.05.14v-.07l-40.06-82.3 48-48a8 8 0 0 0-11.31-11.31l-48 48-82.33-40.06h-.07.14L216 40Z"></path>
  </svg>
)

export const EnvelopeSimple = (props) => (
  <svg
    height="32"
    viewBox="0 0 256 256"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M224 48H32a8 8 0 0 0-8 8v136a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a8 8 0 0 0-8-8m-20.57 16L128 133.15 52.57 64ZM216 192H40V74.19l82.59 75.71a8 8 0 0 0 10.82 0L216 74.19z"></path>
  </svg>
)

export const BracesVariables = (props) => (
  <svg
    height="38"
    viewBox="0 0 38 38"
    width="38"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_81_42)">
      <path
        clipRule="evenodd"
        d="M6.131 19c.29-.317.533-.676.719-1.064.65-1.341.65-2.915.65-4.436 0-3.242.23-4 2.5-4a1.5 1.5 0 0 0 0-3c-2.392 0-4.025.862-4.85 2.564-.65 1.341-.65 2.915-.65 4.436 0 3.242-.23 4-2.5 4a1.5 1.5 0 1 0 0 3c2.27 0 2.5.758 2.5 4 0 1.521 0 3.095.65 4.436C5.975 30.637 7.607 31.5 10 31.5a1.5 1.5 0 1 0 0-3c-2.27 0-2.5-.758-2.5-4 0-1.521 0-3.095-.65-4.436A4.4 4.4 0 0 0 6.131 19M32.369 19a4.4 4.4 0 0 1-.719-1.064C31 16.595 31 15.021 31 13.5c0-3.242-.23-4-2.5-4a1.5 1.5 0 0 1 0-3c2.392 0 4.025.862 4.85 2.564.65 1.341.65 2.915.65 4.436 0 3.242.23 4 2.5 4a1.5 1.5 0 1 1 0 3c-2.27 0-2.5.758-2.5 4 0 1.521 0 3.095-.65 4.436-.825 1.701-2.458 2.564-4.85 2.564a1.5 1.5 0 1 1 0-3c2.27 0 2.5-.758 2.5-4 0-1.521 0-3.095.65-4.436.186-.388.428-.747.719-1.064"
        fillRule="evenodd"
      ></path>
      <path d="M23.512 11.888q.64 0 .992.32.384.288.384.736 0 .32-.128.672-.096.32-.224.672-.735 1.728-3.104 4.832 2.432 3.136 3.936 4.032.128.064.48.224t.544.384q.224.224.224.512 0 .704-.544 1.152-.512.416-1.248.416-1.248 0-2.72-1.376a17.6 17.6 0 0 1-2.496-2.944 22 22 0 0 1-1.696 2.24 26 26 0 0 1-1.728 1.856 2.2 2.2 0 0 1-.768.544 2 2 0 0 1-.832.192q-.576 0-1.024-.256t-.448-.896q0-.16.224-.512.225-.384.256-.448a8 8 0 0 1 1.024-1.376q.64-.735.8-.928.384-.48.832-.928.256-.287.768-.896.512-.608.704-.96l-1.12-1.536a20 20 0 0 0-1.376-1.472q-.576-.576-.928-.576-.511 0-.96.288-.384.255-.768.256-.415 0-.64-.192-.224-.225-.224-.48 0-1.088.864-1.856.864-.8 2.176-.8 1.248 0 2.208.864.992.832 1.952 2.24.128.128.288.416t.32.48a72 72 0 0 0 1.28-1.984q.992-1.76 1.184-2.016.672-.896 1.536-.896"></path>
    </g>
    <defs>
      <clipPath id="clip0_81_42">
        <path d="M0 0h38v38H0z" fill="#fff"></path>
      </clipPath>
    </defs>
  </svg>
)

const Icons = {
  AddUserIcon,
  Alert,
  ArrowDownSmall,
  ArrowLeftSmall,
  ArrowPath,
  ArrowRightSmall,
  ArrowUpSmall,
  ArrowsExpand,
  AzureAD,
  BuildingOffice,
  Chat,
  ChatOutline,
  Check,
  CheckBadge,
  CheckCircle,
  CheckCircleOutline,
  ChevronDoubleRight,
  ChevronDown,
  ChevronLeft,
  ChevronPipeRight,
  ChevronRight,
  ChevronRightSmall,
  ChevronUp,
  ChevronUpDown,
  Clipboard,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Close,
  CloseCircle,
  CloseCircleFilled,
  Cog,
  Copy,
  CubeEmpty,
  Details,
  DetailsActive,
  DeviceTablet,
  DocumentDownload,
  DotsVerticalDense,
  Download,
  Duplicate,
  EnvelopeSimple,
  ExternalLink,
  ExternalLinkDense,
  Eye,
  EyeOff,
  FaceSad,
  Form,
  Gesture,
  KebabMenu,
  Keyboard,
  Link,
  LockClosed,
  MagnifyingGlassMinus,
  MagnifyingGlassPlus,
  Mail,
  MailOutline,
  Merge,
  Packet,
  PaperPlane,
  Pencil,
  Phone,
  PhoneOutline,
  Plus,
  PlusCircle,
  Refresh,
  Search,
  ShieldExclamation,
  SignatureIcon,
  Spinner,
  StatusOffline,
  Support,
  Trash,
  UserAdd,
  UserCircle,
  X,
  FilterAlt,
  TrashCircleAround,
  ArchiveCircleAround,
  BracesVariables,
}

export default Icons
